import { useCallback } from "react";

import type { OptionList } from "@/lib/gql/__generated__/graphql";

import type { DnDResultItem } from "@/hooks/use-dnd/use-dnd";

import { TableRow } from "@/components/ui/table/table";

import { OptionListPageTableItem } from "./item";

type Props = {
	option: DnDResultItem<OptionList["options"][number]>;
	editOptionPagePath: { edit: (optionID: string) => string; createNewItem: string };

	onTransitionToEdit: () => void;
	onDeleteOption: () => Promise<void>;

	isSorting: boolean;
};

export const OptionListPageTableSortableItem = ({
	option,
	editOptionPagePath,
	onTransitionToEdit,
	onDeleteOption,
	isSorting,
}: Props) => {
	const { value } = option;

	const handleClick = useCallback(() => {
		if (isSorting) return;
		onTransitionToEdit();
	}, [isSorting, onTransitionToEdit]);

	return (
		<TableRow
			key={option.key}
			className="select-none hover:cursor-pointer"
			ref={isSorting ? option.events.ref : undefined}
			onMouseDown={isSorting ? option.events.onMouseDown : undefined}
			onClick={handleClick}
		>
			<OptionListPageTableItem
				option={value}
				editOptionPagePath={editOptionPagePath}
				onDeleteOption={onDeleteOption}
				onTransitionToEdit={onTransitionToEdit}
				isSorting={isSorting}
			/>
		</TableRow>
	);
};
